module.exports = __webpack_public_path__ + "img/data-table.1699fa47.jpg";